import Service from "./service.abstract";

export default class ProfileInformationsService extends Service {
  constructor(url: string) {
    super();
    this.url = url;
    this.displayDefaultError = false;
  }
}